/**
 * @module  support/shared/widgets
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Component, OnInit, Input, OnDestroy } from '@angular/core';

@Component({
  selector: 'tmo-see-more-see-less',
  templateUrl: './see-more-see-less.component.html',
})
export class SeeMoreSeeLessComponent implements OnInit, OnDestroy {
  /**
   * String input property to show the legalText title.
   */
  @Input() public inputText: string;
  /**
   * String input property to show the legalText title.
   */
  @Input() public seeMoreText: string;
  /**
   * String input property to show the legalText title.
   */
  @Input() public seeLessText: string;
  /**
   * String input property to show the legalText title.
   */
  @Input() public limit: number;
  /**
   * Boolean property to enable the seeMore/seeLess functionality.
   */
  public seeLess: boolean;

  @Input() public removeRowClass: boolean;
  /**
   * Boolean property to enable the seeMore/seeLess description.
   */
  @Input() public textDisable: boolean;
  /**
   * Boolean property to check if it is Legal text
   */
  @Input() public isLegalText: boolean;

  @Input() public browseService: boolean;

  public showText: string;
  constructor() {
    this.seeLess = false;
    this.removeRowClass = false;
  }

  /**
   * Initializes the data for see-more-less
   * @returns void
   */
  public ngOnInit(): void {
    this.formatInputData();
  }

  /**
   * On more click , showing more text.
   * @returns void.
   */
  public seeMoreClick(): void {
    this.showText = this.inputText;
    this.seeLess = !this.seeLess;
  }

  /**
   *  On less click , showing less text.
   *  @returns void
   */
  public seeLessClick(): void {
    this.formatInputData();
    this.seeLess = !this.seeLess;
  }
  /**
   *  format string for see more and see less
   *  @returns void
   */
  private formatInputData(): void {
    if (this.inputText) {
      this.showText = this.inputText.slice(0, this.limit);
      if (this.limit <= this.inputText.length && this.showText) {
        const conditionalLimit =
          this.inputText.charAt(this.limit) !== ' ' ? this.showText.lastIndexOf(' ') : this.limit;
        this.showText = this.showText.slice(0, conditionalLimit) + '...';
      }
    }
  }

  /**
   * Destroys the subscriptions
   * @returns void
   */
  public ngOnDestroy(): void {}
}
